export const SET_LEADS_CUSTOMER_VALUATION_REQUEST = 'SET_LEADS_CUSTOMER_VALUATION_REQUEST';
export const SET_LEADS_CUSTOMER_VALUATION_REQUEST_SUCCESS = 'SET_LEADS_CUSTOMER_VALUATION_REQUEST_SUCCESS';
export const SET_LEADS_CUSTOMER_VALUATION_REQUEST_FAILURE = 'SET_LEADS_CUSTOMER_VALUATION_REQUEST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/constants/set_customer_valuation.constants.js